import { createContext } from "react";
//import AuthService from "./auth.service";

//const user = AuthService.getCurrentUser();

export const UserContext = createContext(null);